import { makeStyles } from '@material-ui/core/styles';
import { MAX_VIDEO_HEIGHT, MIN_VIDEO_HEIGHT } from 'pages/StreamingWEBRTC/styles';

export const useStyles = makeStyles({
    container: {
        position: 'relative',
    },
    mainVideoContainer: {
        borderRadius: 30,
        backgroundColor: 'black',
        '& video': {
            borderRadius: 30,
            minHeight: MIN_VIDEO_HEIGHT,
            height: MAX_VIDEO_HEIGHT,
        },
    },
    blackBackground: {},
    mainVideoPlaceholderContainer: {
        borderRadius: 30,
        backgroundColor: 'white',
        width: '100%',
        minHeight: MIN_VIDEO_HEIGHT,
        height: MAX_VIDEO_HEIGHT,
    },
    mainVideoPlaceholderImage: {
        maxWidth: 400,
    },
    userCounter: {
        position: 'absolute',
        top: 20,
        left: 20,
        zIndex: 60,
        color: 'white',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        fontSize: 15,

        '& img': {
            maxWidth: 50,
        },
    },
    exitButton: {
        position: 'absolute',
        top: 2.5,
        left: 20,
        zIndex: 65,
        color: 'white',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        '& img': {
            minWidth: 35,
            maxWidth: 50,
        },
    },

    remoteVideo: {
        position: 'absolute',
        zIndex: 2,
        top: 50,
        right: 20,
        maxWidth: '15vw',

        '& video': {
            border: '1px solid white',
            borderRadius: 20,
            webkitBoxShadow: '2px 2px 24px 0px rgba(66, 68, 90, 0.3)',
            mozBoxShadow: '2px 2px 24px 0px rgba(66, 68, 90, 0.3)',
            boxShadow: '2px 2px 24px 0px rgba(66, 68, 90, 0.3)',
            maxHeight: '30vh',
        },
    },
    remoteVideoFullScreenDimensions: {
        maxWidth: '25vw',
        maxHeight: '35vh',
    },
    audioPlayer: {
        height: 0,
        width: 0,
        position: 'absolute',
        zIndex: -1,
        '& video': {
            height: 0,
            width: 0,
        },
    },
});
